export default "__VITE_ASSET__05b61581__"